<template>
  <div class="mini-auth-trigger-wrapper">
    <z-dialog
      v-model="visible"
      business
      show-cancel-button
      :title="title"
      :message="content"
      :confirm-button-text="confirmButtonText"
      :cancel-button-text="cancelButtonText"
      :before-close="beforeClose"
      :btn-props="btnProps"
      @cancel="handleClose"
      @confirm="handleConfirm"
    >
      <div class="z-dialog__content">
        <div class="z-dialog__message">{{ content }}</div>
        <div class="z-dialog__checkbox">
          <z-checkbox-group v-model="check" @change="handleCheck">
            <z-checkbox name="agree" label-disabled>
              <span class="small"
                >我已阅读并同意<a class="high-light" @click.stop="handleUserAgreement"
                  >《用户协议》</a
                >
                及<a class="high-light" @click.stop="handlePrivacyPolicy">《隐私政策》</a>,
                微信小程序登录后会将您的账号与微信进行绑定关联</span
              >
            </z-checkbox>
          </z-checkbox-group>
        </div>
      </div>
    </z-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { Checkbox, CheckboxGroup } from '@zz-yp/hunter-ui'
import { defaultConfig, USER_AGREEMENT, PRIVACY_POLICY } from './config'
import { miniProgramLogin } from '@/lib/miniAuth'

Vue.use(Checkbox).use(CheckboxGroup)

export default {
  props: {
    confirmButtonText: {
      type: String,
      default: defaultConfig.confirmButtonText
    },
    cancelButtonText: {
      type: String,
      default: defaultConfig.cancelButtonText
    },
    title: {
      type: String,
      default: defaultConfig.title
    },
    content: {
      type: String,
      default: defaultConfig.content
    },
    onCancel: {
      type: Function,
      default: () => {}
    },
    targetUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      check: [],
      btnProps: {
        disabled: true
      },
      visible: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('onCancel', 'close')
      this.visible = false
      // this.$el.parentNode.removeChild(this.$el)
    },
    handleConfirm() {
      if (this.check.length) {
        miniProgramLogin(this.targetUrl)
        this.handleClose()
        this.$emit('onConfirm', 'onConfirm')
      }
    },
    beforeClose(action, done) {
      if (action === 'confirm' && !this.check.length) {
        done(false)
        return this.$toast('请阅读并同意《用户协议》及《隐私政策》')
      }
      done()
    },
    handleCheck(val) {
      const isDisabled = !!val.length
      this.btnProps.disabled = !isDisabled
    },
    handleUserAgreement() {
      this.$native.skipToUrl({
        targetUrl: USER_AGREEMENT
      })
    },
    handlePrivacyPolicy() {
      this.$native.skipToUrl({
        targetUrl: PRIVACY_POLICY
      })
    }
  }
}
</script>
<style scoped lang="scss">
.z-dialog__message {
  font-size: 28px;
  padding: 0 0.64rem 0.25rem;
}
.z-dialog__checkbox .z-checkbox {
  align-items: flex-start;
}
.small {
  font-family: PingFangSC-Regular, PingFang SC;
  font-size: 24px;
}
.high-light {
  color: #1677ff;
}
</style>
